/**
 * Created by Jan on 12.05.2017.
 * Jabr: used to be part of the lfl-core-0.1, which was needlessly confusing.
 */
(function (Lfl, $, undefined) {
    /*
     |-------------------------------------------------------------------------------------------------------------------
     | Arrays helper
     |-------------------------------------------------------------------------------------------------------------------
     */

    /**
     * @memberOf Lfl
     */
    Lfl.ArraysHelper = Lfl.ArraysHelper || {};


    (function (ArraysHelper, $, undefined) {
        /**
         * @memberOf Lfl.ArraysHelper
         * @param {Array} array
         * @param {int} index
         * @param {*} item
         */
        ArraysHelper.insert = function (array, index, item) {
            array.splice(index, 0, item);
        };

        /**
         * Removes the element at given index from the array.
         *
         * Source: http://stackoverflow.com/a/5767357/5500468 .
         *
         * @memberOf Lfl.ArraysHelper
         * @param {Array}  array
         * @param {int} index
         */
        ArraysHelper.remove = function (array, index) {
            array.splice(index, 1);
        };

        /**
         * Removes the element from the array.
         *
         * If you know the index of the element, use the remove method.
         *
         * Source: http://stackoverflow.com/a/5767357/5500468 .
         *
         * @memberOf Lfl.ArraysHelper
         * @param {Array}  array
         * @param {*} element
         */
        ArraysHelper.findAndRemove = function (array, element) {
            var index = array.indexOf(element);

            if (index > -1) {
                ArraysHelper.remove(array, index);
            }
        };

    }(Lfl.ArraysHelper, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));